import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {isNil} from 'lodash';

@Directive({
  selector: '[itaxNumberOnly]'
})
export class NumberOnlyDirective {

  // Allow decimal numbers. The \. is only allowed once to occur
  private regex: RegExp = new RegExp(/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(,)\d*)?(?:(\.)\d*)?$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, insurance
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) {
  }

  @Input() maxValue: number;
  @Input() minValue: number;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and insurance keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    const current: string = this.el.nativeElement.value;
    // We need this because the current value on the DOM element
    // is not yet updated with the value from this event
    const next: string = current.concat(event.key);
    if ((event.keyCode === 65 || event.keyCode === 86 || event.keyCode === 67) && (event.ctrlKey === true || event.metaKey === true)) {
      this.checkNumber(next, event);
    } else {
      if (next && !String(next).match(this.regex)) {
        event.preventDefault();
        return;
      }
      this.checkNumber(next, event);
    }
  }

  checkNumber(next: string, event: KeyboardEvent) {
    if (next && (!isNil(this.maxValue) || !isNil(this.minValue))) {
      const numberValue = parseFloat(next);
      if (isNaN(numberValue)
        || (!isNil(this.maxValue) && numberValue > this.maxValue)
        || (!isNil(this.minValue) && numberValue < this.minValue)) {
        event.preventDefault();
        return;
      }
    }
  }
}
